// libraries
import clsx from 'clsx'

// components
import RoundedBox from '/react4xp/components/RoundedBox'
import Image from '/react4xp/components/Image'

// css
import './index.scss'

// types
export interface MacroQuotationCardProps {
    className?: string
    color?: 'green' | 'beige' | 'green-light'
    invert?: boolean
    image?: {
        src?: string
        alt?: string
    }
    quote?: string
    author?: {
        name?: string
        connection?: string
    }
}

export default function MacroQuotationCard({
    className,
    color,
    invert,
    image,
    quote,
    author
}: MacroQuotationCardProps) {
    return (
        <RoundedBox
            bgColor={color}
            className={clsx(
                'quotation-card-macro-component',
                className
            )}
        >
            <div className='row'>
                <div className='col-lg-10 offset-lg-1'>  
                    <div className={clsx(
                        'quotation-card-macro-component__wrapper',
                        invert && 'quotation-card-macro-component__wrapper--invert'
                    )}>

                        <div className='quotation-card-macro-component__image'>
                            {image && (
                                <Image
                                    src={{
                                        src: image?.src || '',
                                        width: 250,
                                        height: 250
                                    }}
                                    alt={image?.alt || ''}
                                    className='cover'
                                    sizes='250px'
                                />
                            )}
                        </div>

                        <div className='quotation-card-macro-component__infos'>

                            {quote && (
                                <h2 className='h2'>
                                    – {quote}
                                </h2>
                            )}

                            {author && (
                                <div className='quotation-card-macro-component__author body'>
                                    <p>
                                        {author.name && author.name}

                                        {author.connection && (
                                            <>
                                                , {author.connection}
                                            </>
                                        )}
                                    </p>
                                </div>
                            )}

                        </div>

                    </div>
                </div>
            </div>
        </RoundedBox>
    )
}